var _path, _path2, _path3, _path4, _path5, _rect, _g, _path6, _path7, _path8, _path9, _rect2, _g2, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotfoungImage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1222,
    height: 146,
    viewBox: "0 0 1222 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M575.96 101.6H564.8V116H537.32V101.6H493.76V83.6L529.4 32H558.44L526.76 79.64H538.16V66.8H564.8V79.64H575.96V101.6Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M745.96 101.6H734.8V116H707.32V101.6H663.76V83.6L699.4 32H728.44L696.76 79.64H708.16V66.8H734.8V79.64H745.96V101.6Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M618.52 117.92C611.08 117.92 604.48 116.2 598.72 112.76C593.04 109.24 588.56 104.2 585.28 97.64C582.08 91 580.48 83.12 580.48 74C580.48 64.88 582.08 57.04 585.28 50.48C588.56 43.84 593.04 38.8 598.72 35.36C604.48 31.84 611.08 30.08 618.52 30.08C625.96 30.08 632.52 31.84 638.2 35.36C643.96 38.8 648.44 43.84 651.64 50.48C654.92 57.04 656.56 64.88 656.56 74C656.56 83.12 654.92 91 651.64 97.64C648.44 104.2 643.96 109.24 638.2 112.76C632.52 116.2 625.96 117.92 618.52 117.92ZM618.52 95.24C624.92 95.24 628.12 88.16 628.12 74C628.12 59.84 624.92 52.76 618.52 52.76C612.12 52.76 608.92 59.84 608.92 74C608.92 88.16 612.12 95.24 618.52 95.24Z",
    fill: "#3FD636"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 67.3125H129.168C131.976 67.1042 137.592 68.5 137.592 75.75C137.592 83 137.592 102.312 137.592 111.062C137.28 114.708 139.402 122 150.384 122C158.808 122 161.304 115.75 161.304 111.062V38.25C161.304 34.5 164.424 27 176.904 27C189.384 27 191.464 36.375 190.944 41.0625V94.1875C191.152 97.1042 193.19 102.938 199.68 102.938C206.17 102.938 208.208 97.1042 208.416 94.1875V71.6875C208.208 70.2292 208.853 67.3125 213.096 67.3125C217.339 67.3125 280.8 67.3125 312 67.3125",
    stroke: "#3FD636",
    strokeWidth: 5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M314.5 50.5778C314.5 46.2985 316.876 42.3732 320.667 40.3889L350.432 24.8111C352.077 23.9499 353.907 23.5 355.764 23.5H384C390.351 23.5 395.5 28.6487 395.5 35V100C395.5 106.351 390.351 111.5 384 111.5H355.707C353.88 111.5 352.079 111.065 350.454 110.23L320.746 94.9739C316.911 93.0044 314.5 89.0553 314.5 84.744V50.5778Z",
    fill: "white",
    stroke: "#3FD636",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_952_4113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 366,
    y: 18,
    width: 32,
    height: 99
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 368.5,
    y: 20.5,
    width: 26.8702,
    height: 93.7351,
    fill: "#3FD636",
    stroke: "black",
    strokeWidth: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_952_4113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.321 50.6906C311.321 46.4273 313.68 42.5138 317.449 40.5224L346.914 24.9563C348.57 24.0817 350.414 23.6245 352.286 23.6245H380.121C386.472 23.6245 391.621 28.7732 391.621 35.1245V100.235C391.621 106.587 386.472 111.735 380.121 111.735H352.228C350.386 111.735 348.571 111.293 346.936 110.445L317.529 95.2011C313.715 93.2243 311.321 89.2869 311.321 84.9914V50.6906Z",
    fill: "#3FD636",
    stroke: "#3FD636",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.312 23.3117V111.111M443.801 97.363L450.362 79.2408",
    stroke: "#3FD636",
    strokeWidth: 5
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M387.441 51.7449H414",
    stroke: "#3FD636",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M387.441 82.9902H414",
    stroke: "#3FD636",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1222 67.3125H1092.83C1090.02 67.1042 1084.41 68.5 1084.41 75.75C1084.41 83 1084.41 102.312 1084.41 111.062C1084.72 114.708 1082.6 122 1071.62 122C1063.19 122 1060.7 115.75 1060.7 111.062V38.25C1060.7 34.5 1057.58 27 1045.1 27C1032.62 27 1030.54 36.375 1031.06 41.0625V94.1875C1030.85 97.1042 1028.81 102.938 1022.32 102.938C1015.83 102.938 1013.79 97.1042 1013.58 94.1875V71.6875C1013.79 70.2292 1013.15 67.3125 1008.9 67.3125C1004.66 67.3125 941.2 67.3125 910 67.3125",
    stroke: "#3FD636",
    strokeWidth: 5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M907.5 50.5778C907.5 46.2985 905.124 42.3732 901.333 40.3889L871.568 24.8111C869.923 23.9499 868.093 23.5 866.236 23.5H838C831.649 23.5 826.5 28.6487 826.5 35V100C826.5 106.351 831.649 111.5 838 111.5H866.293C868.12 111.5 869.921 111.065 871.546 110.23L901.254 94.9739C905.089 93.0044 907.5 89.0553 907.5 84.744V50.5778Z",
    fill: "white",
    stroke: "#3FD636",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_952_4113",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 824,
    y: 18,
    width: 32,
    height: 99
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -2.5,
    y: 2.5,
    width: 26.8702,
    height: 93.7351,
    transform: "matrix(-1 0 0 1 851 18)",
    fill: "#3FD636",
    stroke: "black",
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_952_4113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M910.679 50.6906C910.679 46.4273 908.32 42.5138 904.551 40.5224L875.086 24.9563C873.43 24.0817 871.586 23.6245 869.714 23.6245H841.879C835.528 23.6245 830.379 28.7732 830.379 35.1245V100.235C830.379 106.587 835.528 111.735 841.879 111.735H869.772C871.614 111.735 873.429 111.293 875.064 110.445L904.471 95.2011C908.285 93.2243 910.679 89.2869 910.679 84.9914V50.6906Z",
    fill: "#3FD636",
    stroke: "#3FD636",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M855.688 23.3117V111.111M778.199 97.363L771.638 79.2408",
    stroke: "#3FD636",
    strokeWidth: 5
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 838,
    cy: 54,
    r: 5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 838,
    cy: 80,
    r: 5,
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfoungImage);
export default __webpack_public_path__ + "static/media/notfoung_image.65124c2583e2dfe1e2074e15132a73a9.svg";
export { ForwardRef as ReactComponent };